import { TickIcon } from "../../assets/icons/icon.jsx";
import styles from "./styles.module.css";

const StepProgressBar = ({ steps = [], activeStep = 0 }) => {
  return (
    <div className={styles.root}>
      <div className={`${styles.connector} ${styles.connectorSolid}`} />

      {steps.map((step, index) => {
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;
        return (
          <>
            <div key={index} className={styles.stepItem}>
              <div
                className={`${styles.circle} ${isActive || isCompleted ? styles.circleFilled : ""}`}
              >
                {isCompleted ? (
                  <TickIcon className={styles.checkIcon} />
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={`${styles.label} ${isActive ? styles.labelActive : ""}`}
              >
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <div
                className={`${styles.connector} ${index < activeStep ? styles.connectorSolid : ""}`}
              />
            )}
          </>
        );
      })}

      <div
        className={`${styles.connector} ${activeStep >= steps.length ? styles.connectorSolid : ""}`}
      />
    </div>
  );
};

export default StepProgressBar;
